import React, { useState } from 'react';
import './gallery-carrousel.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
SwiperCore.use([Pagination]);

const GalleryCarrousel = props => {
    const { imagenes, logo } = props;
    const [ imageActive, setImageActive ] = useState(imagenes[0]);
    //console.log(imagenes);
    return (
        <div className="o-gallery-carrousel">
            <div className="o-gallery-carrousel_imagen-active">
                <img src={ imageActive.file.url } alt="imagen principal"/>
            </div>
            <Swiper
                slidesPerView={'auto'}
                className={ `swiper-my length-${ imagenes.length } ${ ( logo ? 'logo' : '' ) }` }
                pagination={{ clickable: true }}
            >
                {
                    imagenes.map( (img, i) => (
                        <SwiperSlide className="slide-preview" key={ i }>
                            <div onClick={ ()=>{ setImageActive(img) } } className={ img === imageActive ? 'active' : '' }>
                                <img src={ img.file.url } alt={"image de carrousel " + i}/>
                            </div>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
            {
                logo && 
                <div className="o-galerry-carrousel_logo-container">
                    <img src={ logo.file.url } alt="logo de carrousel"></img>
                </div>
            }
        </div>
    )
}

export default GalleryCarrousel
